import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyUserRevenueByState.';
  public static readonly monthlyGeneratedRevenue = `${Id.prefix}monthlyGeneratedRevenue`;
  public static readonly order = `${Id.prefix}order`;
  public static readonly quote = `${Id.prefix}quote`;
}

export class LangDashboardBranchMonthlyUserRevenueByState {
  private constructor() {}
  public static monthlyGeneratedRevenue(params: { state: string }): string {
    return interpolate(Id.monthlyGeneratedRevenue, params);
  }
  public static order(): string {
    return interpolate(Id.order);
  }
  public static quote(): string {
    return interpolate(Id.quote);
  }
}

export class DashboardBranchMonthlyUserRevenueByStateModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.monthlyGeneratedRevenue,
      'Monthly Generated Revenue {{state}}',
      'Header for monthly generated revenue by user widget, with quote state'
    );
    register.add(Id.order, "{{glossary 'order'}}", 'Glossary for order');
    register.add(Id.quote, "{{glossary 'quote'}}", 'Glossary for quote');
  }
}
